import { createStore, combineReducers, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import {
  forgotPasswordReducer,
  profileReducer,
  userReducer,
  allUsersReducer,
  userDetailsReducer,
} from "./reducers/userReducer";
import {
  newProductReducer,
  newReviewReducer,
  productDetailsReducer,
  productReducer,
  productsReducer,
  productReviewsReducer,
  reviewReducer,
} from "./reducers/productReducer";
import { cartReducer } from "./reducers/cartReducer";
import { saveForLaterReducer } from "./reducers/saveForLaterReducer";
import {
  allOrdersReducer,
  myOrdersReducer,
  newOrderReducer,
  orderDetailsReducer,
  orderReducer,
  paymentStatusReducer,
  returnOrdersReducer,
} from "./reducers/orderReducer";
import { wishlistReducer } from "./reducers/wishlistReducer";
import {
  newBrandReducer,
  brandDetailsReducer,
  brandReducer,
  brandsReducer,
} from "./reducers/brandReducer";
import { productXLSUploadReducer } from "./reducers/productXLSReducer";
import {
  newSupplierReducer,
  supplierDetailsReducer,
  supplierReducer,
  suppliersReducer,
  supplierSalesReducer,
} from "./reducers/supplierReducer";
import { supplierReturnReducer } from "./reducers/supplierReturnReducer";

const reducer = combineReducers({
  user: userReducer,
  profile: profileReducer,
  forgotPassword: forgotPasswordReducer,
  products: productsReducer,
  productDetails: productDetailsReducer,
  newReview: newReviewReducer,
  cart: cartReducer,
  saveForLater: saveForLaterReducer,
  newOrder: newOrderReducer,
  myOrders: myOrdersReducer,
  paymentStatus: paymentStatusReducer,
  orderDetails: orderDetailsReducer,
  allOrders: allOrdersReducer,
  order: orderReducer,
  newProduct: newProductReducer,
  product: productReducer,
  users: allUsersReducer,
  userDetails: userDetailsReducer,
  reviews: productReviewsReducer,
  review: reviewReducer,
  wishlist: wishlistReducer,
  brand: brandReducer,
  brands: brandsReducer,
  newBrand: newBrandReducer,
  brandDetails: brandDetailsReducer,
  productXLSUpload: productXLSUploadReducer,
  supplier: supplierReducer,
  suppliers: suppliersReducer,
  newSupplier: newSupplierReducer,
  supplierDetails: supplierDetailsReducer,
  supplierSales: supplierSalesReducer,
  returnOrders: returnOrdersReducer,
  supplierReturns: supplierReturnReducer,
});

let initialState = {
  cart: {
    cartItems: localStorage.getItem("cartItems")
      ? JSON.parse(localStorage.getItem("cartItems"))
      : [],
    shippingInfo: localStorage.getItem("shippingInfo")
      ? JSON.parse(localStorage.getItem("shippingInfo"))
      : {},
  },
  saveForLater: {
    saveForLaterItems: localStorage.getItem("saveForLaterItems")
      ? JSON.parse(localStorage.getItem("saveForLaterItems"))
      : [],
  },
  wishlist: {
    wishlistItems: localStorage.getItem("wishlistItems")
      ? JSON.parse(localStorage.getItem("wishlistItems"))
      : [],
  },
};

const middleware = [thunk];

const store = createStore(
  reducer,
  initialState,
  composeWithDevTools(applyMiddleware(...middleware))
);

export default store;
